jQuery(function ($) {
  $('.page__content.rte span').filter(function () {
    return /Round sized bidet seats are 19\.2/.test($(this).text());
  }).each(function () {
    this.style.setProperty('color', '#E62600', 'important');
  });
});

jQuery(function ($) {
  $('img[src*="Comparison-Chart-Bidet-Seats"]')
    .not('[alt]')
    .attr('alt', 'Bidet seat comparison chart: 23 models from 8 brands (Alpha Bidet, BidetKing, Bio Bidet, Brondell, Nova, Blooming, Clean Sense and TOTO) compared on 40 features grouped as nozzles, wash functions and convenience features, plus warranty length. A dot marks each feature a model includes. The full data is in the text table below, under "Show accessible version of this chart."');
});

jQuery(function ($) {
  $('a[href="/products/clean-sense-dib-1500-bidet-seat"]').each(function () {
    if (!$(this).text().trim() && !$(this).attr('aria-label')) {
      $(this).attr('aria-label', 'Clean Sense DIB-1500 Bidet Seat');
    }
  });
});
jQuery(function ($) {
  $('.rte img').filter(function () {
    return !this.getAttribute('src') && !this.getAttribute('srcset') &&
           !this.getAttribute('data-src') && !this.getAttribute('data-srcset');
  }).remove();
});
jQuery(function ($) {
  setTimeout(function () {
    $('.value-picker__choice-list[role="menu"] > a').attr('role', 'menuitem');
    $('label.form__floating-label[for="contact-form-message"]').remove();
    $('textarea[name="h-captcha-response"]').attr('aria-label', 'hCaptcha response');
  }, 5000);
});

(function ($) {
  var SHOGUN_ALTS = {
    '8653aedb-1194-4d22-ba65-72b42a2f516e': 'Three electronic bidet toilet seats under a gold crown with the text Best Bidet Toilet Seats of 2026',
    '1599b605-4073-4de5-a582-98779a35d43e': 'Yahoo Best Tested 2026 award badge',
    'f3a5b767-34d1-4cd4-915a-099a622f2341': 'Forbes Vetted Best of 2026 award badge',
    '32c176b1-dd6d-4507-8f4a-482578d1518d': '5 Best Smart Toilets of 2026',
    '179ec47c-db8d-4ed3-8d78-fd44603e629e': 'Custom Bidet Toilet Combos: build your own today',
    'a9d7707f-6d92-485a-b024-1cdf6d121d93': 'Bidet Buyers Guide',
    'af56b309-bce8-4e63-9c15-82860446c6b0': 'Bidet Seat Installation Guide',
    'ed4cddcc-1a13-4240-8414-6cef8dad3941': 'Toilet Fitment Guide',
    '14c0a937-8219-40bd-a16b-8a9277fbb2ad': 'Bidet seat comparison chart: features compared across Alpha, Bio Bidet, Brondell, Blooming, Clean Sense, Novita and TOTO models'
  };
  var POPUP_ALTS = {
    '73828': '30 Day Money Back Guarantee', '73819': '30 Day Money Back Guarantee',
    '73834': 'BidetKing', '73825': 'BidetKing',
    '73810': 'Map of the continental US showing BidetKing Express Quickship fulfillment warehouse locations',
    '74517': '', '74336': ''
  };

  function applyAlts() {
    $('img.shogun-image').each(function () {
      var m = (this.getAttribute('src') || '').match(/shgcdn\.com\/([0-9a-f-]{36})/);
      if (m && SHOGUN_ALTS.hasOwnProperty(m[1])) this.setAttribute('alt', SHOGUN_ALTS[m[1]]);
    });
    $('img[data-src*="easypopup_content_image_"], img[src*="easypopup_content_image_"]').each(function () {
      var m = (this.getAttribute('data-src') || this.getAttribute('src') || '').match(/easypopup_content_image_(\d+)/);
      if (m && POPUP_ALTS.hasOwnProperty(m[1])) this.setAttribute('alt', POPUP_ALTS[m[1]]);
    });
    $('.header__logo-link img.header__logo-image').attr('alt', '');
    $('img.shogun-image-unsplash-tracker').attr('alt', '');
    $('img.shg-lightbox-image').filter(function () { return !this.getAttribute('src'); }).attr('alt', '');
  }

  $(applyAlts);
  $(window).on('load', applyAlts); // Shogun can re-render after DOM ready
})(jQuery);



/*!
 * bidetking.com — homepage axe remediation (22 issues / 8 rules)
 * Requires jQuery (3.7.1 is loaded site-wide). Load after theme.js.
 *
 *  1. aria-hidden-focus    (1)  hidden hero slides are <a href> and still tabbable
 *  2. color-contrast       (6)  Judge.me reviewer name / timestamp at opacity .8
 *  3. frame-title          (1)  #merchantwidgetiframe has no name
 *  4. list                 (1)  <ol.flickity-page-dots> children carry role=button
 *  5. select-name          (1)  #search-product-type label is display:none
 *  6. aria-allowed-role    (3)  <li role="button"> page dots
 *  7. image-redundant-alt  (4)  collection tiles repeat alt as visible text
 *  8. region               (5)  announcement bar + text-with-icons outside landmarks
 */
(function ($) {
  'use strict';
  if (!$) return;

  var FOCUSABLE = 'a[href], button, input, select, textarea, iframe, summary, [tabindex], [contenteditable="true"]';

  /* ---------- 2. Contrast (CSS) ------------------------------------------ */
  // #677279 at opacity .8 blends to #858e94 (3.34:1). Opacity 1 + #5c666d = 5.87:1.
  if (!document.getElementById('bk-a11y-css')) {
    $('<style id="bk-a11y-css">').text(
      '.jdgm-carousel-item__reviewer-name,' +
      '.jdgm-carousel-item__timestamp{opacity:1!important;color:#5c666d!important}' +
      /* 4/6: real button laid over each 12px dot, 24px target (WCAG 2.5.8) */
      '.flickity-page-dots .dot{position:relative}' +
      '.flickity-page-dots .dot__btn{position:absolute;top:-6px;right:-6px;bottom:-6px;left:-6px;' +
        'margin:0;padding:0;border:0;background:transparent;cursor:pointer;border-radius:50%}' +
      '.flickity-page-dots .dot__btn:focus-visible{outline:2px solid #1A5FB4;outline-offset:1px}'
    ).appendTo('head');
  }

  /* ---------- 1. Hidden hero slides must not be focusable --------------- */
  function syncSlide(slide) {
    var $slide = $(slide);
    var hidden = $slide.attr('aria-hidden') === 'true';

    $slide.filter(FOCUSABLE).add($slide.find(FOCUSABLE)).each(function () {
      var $el = $(this);
      var saved = $el.attr('data-a11y-tabindex');
      if (hidden) {
        if (saved === undefined) {
          var orig = $el.attr('tabindex');
          $el.attr('data-a11y-tabindex', orig === undefined ? '' : orig);
        }
        if ($el.attr('tabindex') !== '-1') $el.attr('tabindex', '-1');
      } else if (saved !== undefined) {
        if (saved === '') $el.removeAttr('tabindex'); else $el.attr('tabindex', saved);
        $el.removeAttr('data-a11y-tabindex');
      }
    });
  }

  /* ---------- 3. Google merchant widget iframe --------------------------- */
  function fixIframe(ctx) {
    $(ctx).find('#merchantwidgetiframe').addBack('#merchantwidgetiframe').each(function () {
      if (!$.trim($(this).attr('title') || '')) $(this).attr('title', 'Google merchant widget');
    });
  }

  /* ---------- 4 + 6. Flickity page dots ---------------------------------- */
  // Flickity only acts on clicks whose target is the <li> (verified live: a click on a
  // child element is ignored), so the inner button forwards activation to its <li>.
  function syncDot(li) {
    var $li = $(li);
    var $btn = $li.children('.dot__btn');
    if (!$btn.length) return;
    if ($li.hasClass('is-selected')) {
      if ($btn.attr('aria-current') !== 'true') $btn.attr('aria-current', 'true');
    } else if ($btn.is('[aria-current]')) {
      $btn.removeAttr('aria-current');
    }
    if ($li.is('[aria-current]')) $li.removeAttr('aria-current');
  }

  function fixDots(ctx) {
    $(ctx).find('.flickity-page-dots').addBack('.flickity-page-dots').each(function () {
      var $dots = $(this).children('li');
      $dots.each(function (i) {
        var $li = $(this);
        var hadFocus = this === document.activeElement;

        // Strip the disallowed semantics from the <li> (keeps it a plain listitem)
        if ($li.is('[role]')) $li.removeAttr('role');
        if ($li.is('[tabindex]')) $li.removeAttr('tabindex');
        if ($li.is('[aria-label]')) $li.removeAttr('aria-label');

        var $btn = $li.children('.dot__btn');
        if (!$btn.length) {
          $btn = $('<button type="button" class="dot__btn"></button>').appendTo($li);
        }
        var label = 'Go to slide ' + (i + 1) + ' of ' + $dots.length;
        if ($btn.attr('aria-label') !== label) $btn.attr('aria-label', label);

        syncDot(this);
        if (hadFocus) $btn.trigger('focus');
      });
    });
  }

  $(document).on('click.bkA11y', '.flickity-page-dots .dot__btn', function (e) {
    e.stopPropagation();          // Flickity ignores this target anyway
    this.parentNode.click();      // native click with target = <li> -> Flickity selects
  });

  /* ---------- 5. Search category <select> -------------------------------- */
  // The <label for> exists but its wrapper .search-bar__filter is display:none at some
  // widths, and its text is just the current value ("All categories").
  function fixSelect(ctx) {
    $(ctx).find('#search-product-type').addBack('#search-product-type').each(function () {
      if (!$.trim($(this).attr('aria-label') || '')) $(this).attr('aria-label', 'Search category');
    });
  }

  /* ---------- 7. Redundant alt on collection tiles ----------------------- */
  function norm(s) { return $.trim(String(s || '')).replace(/\s+/g, ' ').toLowerCase(); }

  function fixRedundantAlt(ctx) {
    $(ctx).find('a.collection-item img[alt]').each(function () {
      var alt = norm(this.getAttribute('alt'));
      if (!alt) return;
      var text = norm($(this).closest('a').text());
      if (text && text.indexOf(alt) !== -1) this.setAttribute('alt', '');
    });
  }

  /* ---------- 8. Landmarks ---------------------------------------------- */
  function fixRegions() {
    var $bar = $('.announcement-bar').first().closest('.shopify-section');
    if ($bar.length && !$bar.is('[role]')) {
      $bar.attr({ role: 'region', 'aria-label': 'Announcement' });
    }
    var $icons = $('.text-with-icons').first().closest('.shopify-section');
    if ($icons.length && !$icons.is('[role]')) {
      $icons.attr({ role: 'region', 'aria-label': 'Why shop with BidetKing' });
    }
  }

  /* ---------- Runner ----------------------------------------------------- */
  function runAll(ctx) {
    ctx = ctx || document;
    $(ctx).find('.slideshow__slide').addBack('.slideshow__slide').each(function () { syncSlide(this); });
    fixIframe(ctx);
    fixDots(ctx);
    fixSelect(ctx);
    fixRedundantAlt(ctx);
    fixRegions();
  }

  $(function () {
    runAll(document);
    $(window).on('load', function () { runAll(document); });

    if (!('MutationObserver' in window) || !document.body) return;

    var pending = null;
    function queue(node) {
      if (pending === null) {
        pending = [];
        (window.requestAnimationFrame || setTimeout)(function () {
          var nodes = pending; pending = null;
          $.each(nodes, function (_, n) { if (n.isConnected) runAll(n); });
        });
      }
      pending.push(node);
    }

    new MutationObserver(function (muts) {
      $.each(muts, function (_, m) {
        var t = m.target;
        if (m.type === 'attributes') {
          if (m.attributeName === 'aria-hidden' && $(t).is('.slideshow__slide')) {
            syncSlide(t);                                    // every slide change
          } else if (m.attributeName === 'class' && $(t).is('.flickity-page-dots > li')) {
            syncDot(t);                                      // mirror is-selected
          } else if ((m.attributeName === 'role' || m.attributeName === 'tabindex') &&
                     $(t).is('.flickity-page-dots > li')) {
            fixDots(t.parentNode);                           // something re-added role=button
          }
        } else if (m.addedNodes.length) {
          queue(t.nodeType === 1 ? t : document);            // Judge.me, merchant widget, section reloads
        }
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'role', 'tabindex']
    });
  });
})(window.jQuery);